<div
    class="info-card d-flex align-items-center"
    [ngClass]="{
        pointer: canSelect,
        'info-card--clickable': linkWholeCard,
    }"
    [attr.data-cy]="primaryInfo"
    (click)="onSelect(); onClick()"
>
    @if (canSelect) {
        <atom-check-box class="me-2" [(checked)]="isSelected"></atom-check-box>
    }

    @if ((avatars && avatars.length) || icon) {
        <div
            [class.divider-end]="avatarIconDivider"
            [class.me-2]="!avatarIconDivider"
        >
            @if (avatars && avatars.length) {
                <molecule-avatar-group-container
                    [avatars]="avatars"
                    [size]="size"
                ></molecule-avatar-group-container>
            }
            @if (icon) {
                <wdx-icon-container
                    size="md"
                    [setBackgroundColor]="icon?.hslColorString | textToHsl"
                >
                    <wdx-icon [icon]="icon.icon ? icon.icon : icon"></wdx-icon>
                </wdx-icon-container>
            }
        </div>
    }

    <div
        class="info-card__information d-block position-relative text-truncate"
        [class.flex-grow-1]="fillHorizontalSpace"
    >
        <div [class.text-truncate]="!compact">
            <h6
                class="{{ textColor ? 'text-' + textColor : '' }}"
                [class.text-truncate]="!compact"
                [class.title]="!compact"
                data-cy="txt-info-card-search"
            >
                @if (!routerLinkData && !modalData && !externalLink) {
                    @if (!ignoreLinkClickedObservers) {
                        @if (hasLinkClickedObservers) {
                            <a
                                #link
                                href="#"
                                (click)="onLinkClicked($event)"
                                click-prevent-default
                                [attr.data-cy]="
                                    cySelector
                                        ? cySelector
                                        : 'btn-quick-link-' + primaryInfo
                                "
                                [attr.data-cy-value]="cyValue"
                                >{{ primaryInfo | translateTokenisedString }}</a
                            >
                        }
                        @if (!hasLinkClickedObservers) {
                            <span
                                [innerHtml]="
                                    primaryInfo | translateTokenisedString
                                "
                            ></span>
                        }
                    }
                    @if (ignoreLinkClickedObservers) {
                        {{ primaryInfo }}
                    }
                }

                @if (externalLink) {
                    <a
                        [href]="externalLink?.externalUrl"
                        [attr.target]="externalLink?.target"
                        [attr.data-cy]="
                            cySelector
                                ? cySelector
                                : 'btn-quick-link-' + primaryInfo
                        "
                        [attr.data-cy-value]="cyValue"
                    >
                        {{ primaryInfo }}
                    </a>
                }

                @if (routerLinkData) {
                    <a
                        #link
                        class="d-block text-truncate info-card-block-link"
                        [routerLink]="!openInNewTab && routerLinkData"
                        [queryParams]="queryParamsData"
                        [attr.data-cy]="
                            cySelector
                                ? cySelector
                                : 'btn-quick-link-' + primaryInfo
                        "
                        [attr.data-cy-value]="cyValue"
                        [innerHtml]="primaryInfo | translateTokenisedString"
                        (click)="onLinkClicked($event)"
                    >
                    </a>
                }
                @if (modalData) {
                    <button
                        class="btn btn-link"
                        [modalId]="modalData?.id"
                        [attr.data-cy]="
                            cySelector
                                ? cySelector
                                : 'btn-quick-link-' + modalData?.id
                        "
                        [attr.data-cy-value]="cyValue"
                    >
                        {{ primaryInfo }}
                    </button>
                }
                @if (primaryInfoIcon) {
                    <wdx-icon
                        class="ms-1"
                        size="fit"
                        [icon]="primaryInfoIcon"
                    ></wdx-icon>
                }
            </h6>
            @if (secondaryInfoTags?.length) {
                <div class="d-flex align-items-center">
                    @for (
                        secondaryInfoTag of secondaryInfoTags;
                        track $index;
                        let first = $first
                    ) {
                        @if (secondaryInfoTag.label) {
                            @if (secondaryInfoTag?.highlight) {
                                <wdx-badge
                                    class="text-truncate"
                                    popoverClass="position-fixed"
                                    triggers="mouseenter:mouseleave"
                                    [class.ms-1]="!first"
                                    [ngbPopover]="secondaryInfoTag.tooltip"
                                    [themeColor]="secondaryInfoTag.highlight"
                                >
                                    {{
                                        secondaryInfoTag.label
                                            | translateTokenisedString
                                    }}
                                </wdx-badge>
                            } @else {
                                <span
                                    class="text-truncate"
                                    [class.ms-1]="!first"
                                    [title]="secondaryInfoTag.label"
                                    >{{
                                        secondaryInfoTag.label
                                            | translateTokenisedString
                                    }}</span
                                >
                            }
                        }
                    }
                </div>
            }

            @if (tertiaryInfo || idList?.length) {
                <wdx-list
                    class="small {{
                        textColor ? 'text-' + textColor : 'text-muted'
                    }} text-truncate"
                >
                    @if (tertiaryInfo) {
                        @for (item of tertiaryInfo; track $index) {
                            @if (item?.label || item?.label === null) {
                                @if (item?.label) {
                                    <li wdxListItem>
                                        <a [routerLink]="item?.routerLink">{{
                                            item?.label
                                                | translateTokenisedString
                                        }}</a>
                                        @if (item.subLabel) {
                                            <div wdxListItemSub>
                                                ({{ item.subLabel }})
                                            </div>
                                        }
                                        @if (item.icon) {
                                            <wdx-icon
                                                wdxListItemIcon
                                                [icon]="item?.icon?.icon"
                                            ></wdx-icon>
                                        }
                                    </li>
                                }
                            } @else {
                                <li
                                    class="d-inline-flex text-truncate"
                                    [title]="item"
                                    wdxListItem
                                >
                                    <div class="text-truncate">
                                        {{ item | translateTokenisedString }}
                                    </div>
                                </li>
                            }
                        }
                    }
                    @if (idList?.length) {
                        <li class="text-truncate">
                            <molecule-identifier-list
                                class="text-truncate"
                                [idList]="idList"
                            ></molecule-identifier-list>
                        </li>
                    }
                </wdx-list>
            }
        </div>
    </div>
    @if (showEditForm && formSetup) {
        <div class="ms-2">
            <molecule-action-button
                [actionButton]="formSetup | fn: formSetupAsEditActionButton"
            ></molecule-action-button>
        </div>
    }
    <ng-content select=".custom-actions"></ng-content>
    @if (canDelete) {
        <atom-icon-button
            class="ms-2"
            data-cy="info-card-close"
            size="sm"
            btnClass="btn"
            icon="trash-alt"
            (onClick)="onDelete()"
        ></atom-icon-button>
    }
</div>

@if (subInfoCards?.length) {
    <table class="timeline sub-info-cards sub-info-cards--{{ size }}">
        @for (subInfoCard of subInfoCards; track $index) {
            <tr class="sub-info-card">
                <td class="timeline-cell timeline-icon-cell">
                    <wdx-icon
                        class="timeline-icon"
                        size="xs"
                        [icon]="['fas', 'circle']"
                    ></wdx-icon>
                </td>
                <td class="timeline-cell">
                    <molecule-info-card
                        [primaryInfo]="subInfoCard.primaryInfo"
                        [secondaryInfo]="subInfoCard.secondaryInfo"
                        [tertiaryInfo]="subInfoCard.tertiaryInfo"
                        [icon]="subInfoCard.icon"
                        [showEditForm]="subInfoCard.showEditForm"
                        [formSetup]="subInfoCard.formSetup"
                        [routerLinkData]="routerLinkData"
                        (linkClicked)="onSubInfoCardLinkClicked(subInfoCard)"
                    ></molecule-info-card>
                </td>
            </tr>
        }
    </table>
}

@if (article?.synopsis) {
    <molecule-article-preview
        class="article-preview--indent d-block py-3"
        [article]="article"
    ></molecule-article-preview>
}
